module.exports = __webpack_public_path__ + "assets/icon-contrast-component.9d8a1c79.svg";